import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { isEqual } from "lodash";

import { FormField } from "../../../../sharedComponents/formField";
import { required, isDec3 } from "../../../../constants/formValidators";

const NutrientDataForm = ({ foodId, initialValues, list, handleSubmit, onSubmit, isView, setActiveTab }) => {
	const [submitting, setSubmitting] = useState(false);

	const validateForm = (values) => {
		const fields = Object.keys(values).map((key) => {
			return {
				id: Number(key.split("_")[1]),
				nut_val: values[key],
				food: foodId,
			};
		});

		setSubmitting(true);

		if (isEqual(initialValues, values)) {
			onSubmit();
			setSubmitting(false);
		} else {
			onSubmit({ id: foodId, data: fields });
		}
	};

	const nextTab = () => {
		setActiveTab(2);
	}

	return initialValues ? (
		<form onSubmit={handleSubmit(validateForm)}>
			<div className="row">
				{
					list.length !== 0
						? list.map((item, index) => (
							<Field
								key={index}
								label={`${item.nut_data.name} (${item.nut_data.units})`}
								name={`field_${item.id}`}
								type={isView ? "nutrition_label" : "number"}
								formGroupClass={isView ? "col-3 row" : "col-3"}
								component={FormField}
								validate={[required, isDec3]}
								min="0"
								max="9999"
								step="0.001"
								onChange={() => setSubmitting(false)}
							/>
						))
						: (
							<div className="alert alert-info text-center w-100 m-3 no-exercises-found">
								<div>No data found!</div>
							</div>
						)
				}
			</div>
			<div className="text-right mt-4">
				{
					isView
						?
						<button type="button" className="btn btn-primary-dark text-uppercase" onClick={nextTab}>
							Next
						</button>
						:
						<button className="btn btn-primary-dark" type="submit" disabled={submitting}>
							Save &amp; Next
						</button>
				}
			</div>
		</form>
	) : null;
};

export default connect()(
	reduxForm({
		form: "NutrientDataForm",
		enableReinitialize: true,
	})(NutrientDataForm)
);

